import React from 'react'

export const TestBAlert = () => {
  return (
    <div>
         <div class="alert alert-warning" role="alert">
        Please expect delays in transaction processing due to high network congestion on the Test Blockchain. 
</div>
    </div>
  )
}
